module.exports = __webpack_public_path__ + "2751f2e1741e25a0ad24261928b67c4d.MP3";